import { render, staticRenderFns } from "./popup-set-spec.vue?vue&type=template&id=46ba4a82&scoped=true"
import script from "./popup-set-spec.vue?vue&type=script&lang=js"
export * from "./popup-set-spec.vue?vue&type=script&lang=js"
import style0 from "./popup-set-spec.vue?vue&type=style&index=0&id=46ba4a82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba4a82",
  null
  
)

export default component.exports